import { useNavigate, useLocation, } from 'react-router-dom';
import { Formik, Form, Field, } from 'formik';
import * as yup from 'yup';
import {
    Box,
    Modal,
    Typography,
    TextField,
    Button,
    Stack, } from '@mui/material';
import { useSnackbar, } from 'notistack';
import { useApp, useAuth, useFirestore, } from '../../hooks';

const initialValues = {
    title: '',
    description: '',
};

const validationSchema = yup.object({
    title: yup
        .string()
        .min(1, 'Название папки должно состоять минимум из 1 символа')
        .max(50, 'Название папки может состоять не более чем из 50 символов')
        .required('Название папки обязательно к заполнению'),
    description: yup
        .string()
        .max(500, 'Описание папки может состоять не более чем из 500 символов'),
});

const NewFolderModal = () => {
    const { newFolderModalIsOpen, newFolderModalClose, } = useApp();
    const { user, } = useAuth();
    const { addDocument, response: { isPending, }, } = useFirestore('folders');
    const { enqueueSnackbar, } = useSnackbar();
    const navigate = useNavigate();
    const { pathname, } = useLocation();

    const onSubmit = async ({ title, description, }) => {
        const data = {
            title,
            uid: user.uid,
        };

        if (description.trim()) {
            data.description = description;
        }

        const res = await addDocument(data);

        if (res) {
            newFolderModalClose();
            enqueueSnackbar(`Папка «${title}» создана`, { variant: 'success', });

            if (!pathname.startsWith('/set/')) {
                navigate(`/folder/${res.id}`);
            }
        }
    };

    return (
        <Modal
            open={newFolderModalIsOpen}
            onClose={newFolderModalClose}
            aria-labelledby='new-paper-modal-title'
        >
            <Box sx={{width: ['95%', '80%', '70%', '50%'],}}>
                <Typography id='new-paper-modal-title' component='h2' sx={{
                    fontSize: [24, 25, 26, 27],
                    fontWeight: 700,
                    mb: [3, 4, 5, 6], }}>
                    Создание новой папки
                </Typography>

                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    validateOnChange={false}
                    validateOnBlur={false}
                >
                    {
                        (formik) => {
                            return (
                                <Form autoComplete='off'>
                                    <Field name='title'>
                                        {
                                            (props) => {
                                                const { field, meta: { error, touched, }, } = props;

                                                return <TextField
                                                    {...field}
                                                    color='secondary'
                                                    fullWidth
                                                    label='Название папки'
                                                    error={touched && Boolean(error)}
                                                    helperText={touched && error}
                                                    sx={{mb: [2, 2, 3],}}
                                                />
                                            }
                                        }
                                    </Field>
                                    <Field name='description'>
                                        {
                                            (props) => {
                                                const { field, meta: { error, touched, }, } = props;

                                                return <TextField
                                                    {...field}
                                                    color='secondary'
                                                    fullWidth
                                                    label='Краткое описание (не обязательно)'
                                                    error={touched && Boolean(error)}
                                                    helperText={touched && error}
                                                    sx={{mb: [3, 3, 4],}}
                                                />
                                            }
                                        }
                                    </Field>

                                    <Stack direction='row' justifyContent='flex-end'>
                                        <Button
                                            type='submit'
                                            disabled={isPending || !formik.dirty}
                                            onClick={() => formik.validateForm()}
                                            sx={{
                                                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'common.kashmirBlue',
                                                boxShadow: 2,
                                                color: 'common.white',
                                                py: 1,
                                                px: 1.5,
                                                '&:hover': {
                                                    bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'common.kashmirBlue',
                                                },
                                                '&:disabled': {
                                                    color: 'rgba(255, 255, 255, 0.26)',
                                                },
                                            }}>{ isPending ? 'Создаём...' : 'Готово' }</Button>
                                    </Stack>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Box>
        </Modal>
    );
};

export default NewFolderModal;